import { OptionsWithBackground } from "../../../../shared";
import background from "./bg.png";
import hot from "@assets/img/emoji/hot.png";
import nice from "@assets/img/emoji/nice.png";

const data = [
  {
    displayValue: "Yes",
    value: "1",
    emoji: hot
  },
  {
    value: "2",
    displayValue: "No",
    emoji: nice
  }
];

export const Headaches = ({ onNextStep, onTrackEvent }) => {
  const handleNextStep = (v) => {
    console.log(v);
    onNextStep?.();
    onTrackEvent?.(v.displayValue);
  };

  return (
    <OptionsWithBackground
      data={data}
      title="Do you get headaches a lot?"
      onClick={handleNextStep}
      background={background}
    />
  );
};
